module.exports = __webpack_public_path__ + "static/media/power.1e570df4.svg";